/* eslint-disable no-undef,import/no-mutable-exports */
let baseUrl = '/api/v1';
let lifeRayUrl = '/api/jsonws/invoke';

if (process.env.NODE_ENV === 'production') {
    baseUrl = '/api/v1';
    lifeRayUrl = '/api/jsonws/invoke';
}

let settings = {
    baseUrl,
    lifeRayUrl,
    env: process.env.NODE_ENV,
    loadTimeout: 300000,
    preloadTimeout: 100000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    storagePrefix: '@CSI',
    defaultLocale: 'en',
    liferay_username: 'info@semapnticpro.org',
    liferay_password: 'test',
    DEFAULT_COMPANY_ID: 153,
    DEFAULT_OPERATOR_ID: 1001,
    DEFAULT_DEVICE_ID: 41906,
    DEFAULT_PORTLET_ID: 1,
    DEFAULT_ROUTE_ID: 52,
    SPINNER_DELAY: 3000,
    IMAGES_URL: '/o/inspinia/images',
    SHIFT_AMOUNT: 300,
    color: '#1ab394',
};

export default settings;
